import React from 'react'

import { HeaderSlot } from '@caudena/core/Layout/slots'
import { ColDeprecated } from '@caudena/core/ui-kit'
import { Typography } from '@caudena/core/ui-kit'
import { ConfirmButton } from '@caudena/core/ui-kit'
import http from '@caudena/core/http'
import { useNavigate } from '@caudena/core/Router/router'

import SettingsHeader from '../SettingsHeader'
import buildUrl from '@caudena/core/utils/buildUrl'
import { getConfig } from '@caudena/core/useConfig'

const FullReset: React.FC = () => {
  const nav = useNavigate()

  HeaderSlot.useContent(() => <SettingsHeader />)

  const reset = async () => {
    await http.post(buildUrl`${getConfig()?.COMPLIANCE_API}/api/settings/reset`)
    nav('/dashboard')
  }

  return (
    <ColDeprecated align="left">
      <Typography variant="subheading1">
        All data will be permanently deleted
      </Typography>
      <ConfirmButton
        onClick={reset}
        acceptText="yes"
        cancelText="cancel"
        title={
          <>
            Are you sure you want to permanently delete all data?
            <br />
            Recovery will not be possible
          </>
        }
        variant="solid"
        color="critical"
      >
        reset
      </ConfirmButton>
    </ColDeprecated>
  )
}

export default FullReset
